/**
 * FormLockedCard — shown in place of the question panel when forms are locked.
 *
 * By default renders the Adult ADHD copy ("Assessment is already underway").
 * CYP ADHD informant views pass the `variant` prop to switch the language to
 * child-first copy appropriate for parent/carer or school respondents:
 *   "This questionnaire has been locked because {childName}'s assessment is
 *    already underway."
 *
 * The component stays render-only — lock enforcement happens in GenericFormPage
 * (save guard) and Firestore rules (server-side deny).
 */
export default function FormLockedCard({ variant, childName }) {
  if (variant === 'cypInformant') {
    // CYP ADHD informant view — personalised with the child's first name.
    const nameFragment = childName ? `${childName}'s` : 'the child\'s';
    return (
      <div className="text-center">
        <h2 className="text-2xl font-bold mb-4">Questionnaire locked</h2>
        <p className="mb-2">
          This questionnaire has been locked because {nameFragment} assessment is already underway.
        </p>
        <p className="mb-2">You can view your previous answers below, but they can no longer be changed.</p>
        <p>If you need to make changes, please contact your clinician.</p>
      </div>
    );
  }

  // Default: Adult ADHD patient view.
  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-4">Form Locked</h2>
      <p className="mb-2">This form has been locked because your Assessment is already underway.</p>
      <p className="mb-2">You can view your previous answers below, but they can no longer be modified.</p>
      <p>If you need to make changes, please contact your healthcare provider.</p>
    </div>
  );
}
